<template>
  <el-dialog
    title="月报追踪"
    :visible.sync="trackMonthOpen"
    width="1500px"
    :close-on-click-modal="false"
    append-to-body
  >
    <div style="margin-left: 30px">
      <div style="font-size: 18px; color: #000; font-weight: bold">
        一、课题基本情况
      </div>
      <el-divider></el-divider>
      <div>
        <el-form v-model="trackMonth" label-width="200px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="课题名称:">{{
                trackMonth.courseName
              }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="最终成果形式:">{{
                trackMonth.finalAchievementForm
              }}</el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="课题负责人:">{{
                trackMonth.courseLeader
              }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="课题类型:">{{
                trackMonth.courseType
              }}</el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="拟结项日期:">
                <el-date-picker
                  v-model="trackMonth.closingItemApplyTime"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyyMMdd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="总体进展度:">
                <el-input
                  v-model="trackMonth.overallProgress"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  min="0"
                  max="100"
                  type="number"
                  @input="numberChange(arguments[0], 100)"
                  @change="numberChange(arguments[0], 100)"
                >
                  <i
                    slot="suffix"
                    style="font-style: normal; margin-right: 10px"
                    >%</i
                  >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div>
        <div style="font-size: 18px; color: #000; font-weight: bold">
          二、课题研究阶段进度分析
          <el-button
            type="primary"
            style="margin-left: 20px"
            icon="el-icon-plus"
            size="small"
            @click="handleAdd()"
            v-show="isAddPermissions >= 1"
            >添加</el-button
          >
        </div>
        <el-divider></el-divider>
        <el-table
          v-loading="loading"
          :data="trackMonthResult"
          fit
          stripe
          border
          :header-cell-style="{ background: '#ffffff', fontWeight: 'bolder' }"
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
        >
          <el-table-column
            label="操作"
            min-width="180"
            align="center"
            class-name="small-padding fixed-width"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="handleDelete(scope.row.id, scope.row.status)"
                v-show="scope.row.permissions.isedit == 1"
                icon="el-icon-delete"
                >删除</el-button
              >
              <el-button
                size="mini"
                type="text"
                @click="handleEdit(scope.row, scope.row.status)"
                v-show="scope.row.permissions.isedit == 1"
                icon="el-icon-edit"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="text"
                @click="
                  handleMake(scope.row.id, scope.row.status, scope.row.courseId)
                "
                v-show="scope.row.permissions.isexamine == 1"
                icon="el-icon-s-check"
                >审核</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="序号"
            prop="sort"
            min-width="100px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            align="center"
            label="当前所处阶段"
            prop="stepName"
            min-width="150px"
            :show-overflow-tooltip="true"
          />
          <el-table-column label="进度计划" align="center">
            <el-table-column
              label="开始时间"
              align="center"
              prop="startTime"
              min-width="150px"
              :show-overflow-tooltip="true"
            />
            <el-table-column
              label="结束时间"
              prop="endTime"
              align="center"
              min-width="150px"
              :show-overflow-tooltip="true"
            />
          </el-table-column>
          <el-table-column
            label="目前完成情况"
            align="center"
            min-width="150px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="detailed(scope.row.courseComplete, '目前完成情况详细')"
                >{{ scope.row.courseComplete }}</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="导师辅导情况"
            min-width="150px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="detailed(scope.row.tutorCoach, '导师辅导情况详细')"
              >
                {{ scope.row.tutorCoach == null ? "-" : scope.row.tutorCoach }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="面临的困难或问题"
            min-width="150px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="detailed(scope.row.problems, '面临的困难或问题详细')"
                >{{ scope.row.problems }}</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            label="是否存在延期风险"
            align="center"
            min-width="150px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="detailed(scope.row.risk, '是否存在延期风险详细')"
                >{{ scope.row.risk }}</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="填写日期"
            prop="createTimes"
            min-width="100px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="风险预警等级"
            align="center"
            min-width="120px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span :class="scope.row.riskWarning | statusFilter">{{
                scope.row.riskWarning | formatStata
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="问题及意见"
            align="center"
            min-width="120px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="detailed(scope.row.advice, '问题及意见详细')"
                >{{
                  scope.row.advice == null ? "-" : scope.row.advice
                }}</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            label="处理人"
            prop="solveBy"
            align="center"
            min-width="120px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">{{
              scope.row.solveBy == null ? "-" : scope.row.solveBy
            }}</template>
          </el-table-column>
          <el-table-column
            label="处理时间"
            align="center"
            min-width="120px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">{{
              scope.row.solveTime == null ? "-" : scope.row.solveTime
            }}</template>
          </el-table-column>
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="submitForm()">确 定</el-button>
        <el-button @click="cancel()">取 消</el-button>
      </div>
      <add v-if="openDialog" ref="testDialog" @childEvent="getlist()"></add>
      <edit v-if="openDialogEdit" ref="testDialogEdit"></edit>
      <make
        v-if="openDialogMake"
        ref="testDialogMake"
        @childEvent="getlist()"
      ></make>
      <el-dialog
        :visible.sync="detailOpen"
        :title="detailTitle"
        width="750px"
        :modal-append-to-body="false"
        append-to-body
      >
        <el-input
          v-model="detail"
          style="width: 700px"
          type="textarea"
          :rows="15"
          :readonly="true"
        />
      </el-dialog>
    </div>
  </el-dialog>
</template>

<script>
import {
  trackResult,
  getCourse,
  deleteTrack,
  insertTrack,
} from "@/api/trackMonth";
import add from "./add.vue";
import edit from "./edit.vue";
import make from "./make.vue";
export default {
  name: "trackMonth",
  components: { add, edit, make },
  data() {
    return {
      total: 0,
      trackMonth: {},
      trackMonthResult: [],
      courseId: "",
      openDialog: false,
      openDialogEdit: false,
      openDialogMake: false,
      isAdd: 1,
      total: 0,
      page: 1,
      pageSize: 5,
      isAddPermissions: 1,
      loading: true,
      detailOpen: false,
      detail: "",
      detailTitle: "",
      trackMonthOpen: false,
    };
  },
  filters: {
    // el-tag类型转换
    statusFilter(status) {
      const statusMap = {
        1: "red_area",
        2: "yellow",
        3: "green",
        null: "",
      };
      return statusMap[status];
    },
    // 状态显示转换
    formatStata(status) {
      const statusMap = {
        1: "高风险",
        2: "中风险",
        3: "低风险",
        null: "-",
      };
      return statusMap[status];
    },
  },
  created() {},
  methods: {
    init(courseId) {
      this.courseId = courseId;
      this.trackMonthOpen = true;
      this.getlist();
      this.getCourseMain();
    },
    getlist() {
      this.loading = true;
      trackResult(this.courseId, this.page, this.pageSize).then((res) => {
        if (res.code == 0) {
          this.loading = false;
          this.trackMonthResult = res.data;
          this.total = res.count;
        }
      });
    },
    getCourseMain() {
      getCourse(this.courseId).then((res) => {
        if (res.code == 0) {
          this.trackMonth = res.data.trackMonth;
          this.isAdd = res.data.isAdd;
          this.isAddPermissions = res.data.isAddPermissions;
        }
      });
    },
    handleDelete(id, status) {
      if (status == 1) {
        this.$message.warning("结果已经处理，不能删除！");
        return;
      }
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return deleteTrack(id);
        })
        .then((res) => {
          if (res.code == 0) {
            this.getlist();
            this.$notify({
              title: "成功",
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$notify({
              title: "失败",
              message: res.msg,
              type: "error",
              duration: 2000,
            });
          }
        })
        .catch(() => {});
    },
    handleAdd() {
      if (this.isAdd == 0) {
        this.$message.error("请先提交基本情况，再新增计划！");
      } else {
        this.openDialog = true;
        this.$nextTick(() => {
          this.$refs.testDialog.init(this.courseId);
        });
      }
    },
    handleEdit(track, status) {
      if (status == 1) {
        this.$message.warning("结果已经处理，不能编辑！");
        return;
      }
      this.openDialogEdit = true;
      this.$nextTick(() => {
        this.$refs.testDialogEdit.init(this.courseId, track);
      });
    },
    handleMake(id, status, courseId) {
      if (status == 1) {
        this.$message.warning("结果已经处理，不能审核！");
        return;
      }
      this.openDialogMake = true;
      this.$nextTick(() => {
        this.$refs.testDialogMake.init(id, courseId);
      });
    },
    numberChange(val, maxNum) {
      this.trackMonth.overallProgress = Number(val);
      this.$nextTick(() => {
        //比较输入的值和最大值，返回小的
        let num = Math.min(Number(val), maxNum);
        if (num < 0) {
          this.trackMonth.overallProgress = 0;
        } else {
          this.trackMonth.overallProgress = num;
        }
      });
    },
    submitForm() {
      insertTrack(this.trackMonth).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
          this.getCourseMain();
        } else {
          this.$notify({
            title: "失败",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getlist();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getlist();
    },
    detailed(detial, detailTitle) {
      this.detailOpen = true;
      this.detailTitle = detailTitle;
      this.detail = detial;
    },
    cancel() {
      this.trackMonthOpen = false;
    },
  },
};
</script>

<style lang="less" scoped>
.el-form-item {
  display: inline-block !important;
}
.el-table::before {
  height: 0px;
}
.el-table--border::after {
  width: 0px;
}
.el-table--border {
  border: none;
}
/deep/ .el-table__row > td {
  /* 去除表格线 */
  border-right: none;
}
.red_area {
  color: #fff;
  height: 28px;
  background-color: #ff0000;
  text-align: center;
  font-size: 12px;
  padding: 2px 15px;
  line-height: 28px;
  border-radius: 3px;
}
.yellow {
  color: #999;
  height: 28px;
  background-color: #ffff80;
  text-align: center;
  font-size: 12px;
  padding: 2px 15px;
  line-height: 28px;
  border-radius: 3px;
}
.green {
  color: #fff;
  height: 28px;
  background-color: #4b7902;
  text-align: center;
  font-size: 12px;
  padding: 2px 15px;
  line-height: 28px;
  border-radius: 3px;
}
</style>